import styled from "styled-components";

export default styled.div`
  margin-top: 4rem;
  margin-bottom: 4rem;

  .groups-home-page {
  }
`;
